import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';

export default class PropertyTagsUser extends Model {
  [Type] = 'property-tags/user' as const;

  @attr('string') declare name: string;
}
